import { render, staticRenderFns } from "./ConstructorMultipleAnswer.vue?vue&type=template&id=e94f67ba&scoped=true&"
import script from "./ConstructorMultipleAnswer.vue?vue&type=script&lang=js&"
export * from "./ConstructorMultipleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94f67ba",
  null
  
)

export default component.exports